// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__1o-Fp","AppMobile":"App__AppMobile__3gg1I"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 789
// module chunks = 0